import React from 'react';
import LegalPage, { LegalSection as Section } from '../components/LegalPage';

const COOKIE_TABLE = [
  { name: 'waslx_session', purpose: 'Keeps you logged in', duration: 'Session', type: 'Essential' },
  { name: 'waslx_prefs',   purpose: 'Remembers your UI preferences (dark mode, sidebar state)', duration: '1 year', type: 'Functional' },
  { name: 'csrf_token',    purpose: 'Protects form submissions against cross-site request forgery', duration: 'Session', type: 'Essential' },
];

const CookiePolicy = () => (
  <LegalPage
    title="Cookie Policy"
    description="WASLX cookie policy — we use only essential cookies to run the platform. No advertising trackers, no third-party pixels. Learn what cookies we set and why."
    path="/cookie-policy"
    heading="Cookie Policy"
    updated="April 27, 2025"
  >
    <>
        <Section title="1. What are cookies?">
          <p>Cookies are small text files placed on your device by a website. They are widely used to make websites work, to remember your preferences, and to provide information to site owners.</p>
        </Section>

        <Section title="2. How WASLX uses cookies">
          <p>We use only the cookies necessary to run the platform. We do not use advertising cookies, tracking pixels, or third-party analytics that track you across other websites.</p>
        </Section>

        <Section title="3. Cookies we set">
          {/* Table rules: muted header row, hairline separators, no vertical
              rules ever, and the wrapper scrolls rather than the page. */}
          <div className="overflow-x-auto rounded-lg bg-surface shadow-soft">
            <table className="w-full text-[0.9375rem]">
              <thead>
                <tr className="border-b border-line bg-surface-muted">
                  {['Cookie', 'Purpose', 'Duration', 'Type'].map(head => (
                    <th
                      key={head}
                      className="px-4 py-3 text-left text-2xs font-bold uppercase tracking-[0.08em] text-content-muted"
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {COOKIE_TABLE.map(row => (
                  <tr key={row.name} className="border-b border-line last:border-0">
                    <td className="whitespace-nowrap px-4 py-3 font-mono text-sm text-primary-strong">
                      {row.name}
                    </td>
                    <td className="px-4 py-3 text-content">{row.purpose}</td>
                    <td className="whitespace-nowrap px-4 py-3 text-content-muted">{row.duration}</td>
                    <td className="px-4 py-3">
                      <span className={`chip ${row.type === 'Essential' ? 'chip--info' : 'chip--neutral'}`}>
                        {row.type}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Section>

        <Section title="4. Third-party cookies">
          <p>We do not currently embed third-party services that set cookies (such as advertising networks or social media trackers). If this changes, we will update this policy and notify you.</p>
        </Section>

        <Section title="5. Managing cookies">
          <p>You can control and delete cookies through your browser settings. Deleting or blocking essential cookies will prevent you from logging in and using WASLX.</p>
          <p>For instructions specific to your browser, visit:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Chrome: Settings → Privacy and security → Cookies and other site data</li>
            <li>Firefox: Settings → Privacy &amp; Security → Cookies and Site Data</li>
            <li>Safari: Preferences → Privacy → Manage Website Data</li>
            <li>Edge: Settings → Cookies and site permissions</li>
          </ul>
        </Section>

        <Section title="6. Changes to this policy">
          <p>We may update this Cookie Policy occasionally. Changes will be posted here with an updated date. For significant changes, we will notify you by email.</p>
        </Section>

        <Section title="7. Contact">
          <p>Questions? Email <strong>hello@waslx.co.in</strong>.</p>
        </Section>
    </>
  </LegalPage>
);

export default CookiePolicy;
